export default "__VITE_ASSET__DjZLDblu__"